import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { MainLayout } from "../components/Common/MainLayout/mainlayout";
import AuthProtected from "./AuthProtected";
import {
  getPasswordResetPath,
  getUrlToken,
} from "../utils/urlTokenAuth";

const RootEntry = () => {
  const location = useLocation();
  const urlToken = getUrlToken(location.search);

  if (urlToken && location.pathname === "/") {
    return <Navigate to={getPasswordResetPath(urlToken)} replace />;
  }

  return (
    <AuthProtected>
      <MainLayout />
    </AuthProtected>
  );
};

export default RootEntry;
